import {TriSelection} from 'api-types/ffconnect';

/**
 * Trie les catégories par ordre alphabétique et filtre les articles selon une map donnée
 * @param triSelection - La structure TriSelection à trier et filtrer
 * @param itemsMap - Map contenant les éléments indexés par code d'article
 * @returns Un tableau de catégories triées avec leurs articles filtrés et leurs données associées
 */
export function trierEtFiltrerCategories<T>(
  triSelection: TriSelection,
  itemsMap: Map<string, T>,
): ({
  categorie_id: string;
  libelle_web: string;
  libelle_court: string;
  articles: T[];
} | null)[] {
  return triSelection
    .sort((a, b) => a.libelle_web.localeCompare(b.libelle_web))
    .map(({categorie_id, libelle_web, libelle_court, articles}) => {
      // Filtrer les articles qui sont dans la map et récupérer leurs données
      const articlesFiltered = articles
        .filter((article) => itemsMap.has(article.code))
        .map((article) => itemsMap.get(article.code)!);

      if (articlesFiltered.length === 0) return null;

      return {
        categorie_id,
        libelle_web,
        libelle_court,
        articles: articlesFiltered,
      };
    });
}
